import React, { useEffect, useState } from 'react';
import { Image, Text } from '@fluentui/react';
import { DirectionsRenderer, InfoWindow, Marker } from '@react-google-maps/api';

interface IGoogleMapMarkerWaypointComponentProps {
    startCoordinates: google.maps.LatLngLiteral;
    endCoordinates: google.maps.LatLngLiteral;
    startIconUrl: string;
    endIconUrl: string;
    titleStart: string;
    textStart: string;
    titleEnd: string;
    textEnd: string;
};

const GoogleMapMarkerWaypointComponent = (props: IGoogleMapMarkerWaypointComponentProps) => {
    const [directions, setDirections] = useState<google.maps.DirectionsResult>();
    const [selectedStart, setSelectedStart] = useState<boolean>(false);
    const [selectedEnd, setSelectedEnd] = useState<boolean>(false);

    useEffect(() => {
        if (props.startCoordinates && props.endCoordinates && props.startCoordinates !== props.endCoordinates) {
            const directionsService : google.maps.DirectionsService = new google.maps.DirectionsService();
            directionsService.route({
                origin: props.startCoordinates,
                destination: props.endCoordinates,
                travelMode: google.maps.TravelMode.DRIVING,
            }, (result: google.maps.DirectionsResult | null, status: google.maps.DirectionsStatus) => {
                if (result && status === google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                }
                else {
                    console.error(`error fetching directions ${result}`);
                }
            });
        }
        else {
            setDirections(undefined);
        }
    }, [props.startCoordinates, props.endCoordinates]);

    return (
        <>
            {
                props.startCoordinates ? (
                    <Marker 
                        position={props.startCoordinates}
                        onClick={() => setSelectedStart(!selectedStart)}>
                        {
                            selectedStart ? (
                                <InfoWindow onCloseClick={() => setSelectedStart(false)}>
                                    <div className='row align-items-center m-0'>
                                        <div className='col-auto p-0'>
                                            {
                                                props.startIconUrl ? (
                                                    <Image src={props.startIconUrl} height={30} width={30} />
                                                ) : (
                                                    null
                                                )
                                            }
                                        </div>
                                        <div className='col p-0'>
                                            <Text variant="medium">
                                                <strong>
                                                    {props.titleStart}
                                                </strong>
                                            </Text>
                                        </div>
                                        <div className='col-12 p-0'>
                                            <Text>
                                                {props.textStart}
                                            </Text>
                                        </div>
                                    </div>
                                </InfoWindow>
                            ) : (
                                null
                            )
                        }
                    </Marker>
                ) : (
                    null
                )
            }
            {
                props.endCoordinates ? (
                    <Marker 
                        position={props.endCoordinates}
                        onClick={() => setSelectedEnd(!selectedEnd)}>
                        {
                            selectedEnd ? (
                                <InfoWindow onCloseClick={() => setSelectedEnd(false)}>
                                    <div className='row align-items-center m-0'>
                                        <div className='col-auto p-0'>
                                            {
                                                props.endIconUrl ? (
                                                    <Image src={props.endIconUrl} height={30} width={30} />
                                                ) : (
                                                    null
                                                )
                                            }
                                        </div>
                                        <div className='col p-0'>
                                            <Text variant="medium">
                                                <strong>
                                                    {props.titleEnd}
                                                </strong>
                                            </Text>
                                        </div>
                                        <div className='col-12 p-0'>
                                            <Text>
                                                {props.textEnd}
                                            </Text>
                                        </div>
                                    </div>
                                </InfoWindow>
                            ) : (
                                null
                            )
                        }
                    </Marker>
                ) : (
                    null
                )
            }
            {
                directions ? (
                    <DirectionsRenderer 
                        directions={directions}
                        options={{
                            polylineOptions: {
                                strokeColor: "#ed6d63",
                                strokeOpacity: 1,
                                strokeWeight: 5,
                            },
                            markerOptions: {
                                visible: false,
                            },
                        }} />
                ) : (
                    null
                )
            }
        </>
    );
};

export default GoogleMapMarkerWaypointComponent;
